<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">{{type=='minus' ? 'Reduce Stock' : 'Add Stock'}}</v-toolbar-title>
		</v-toolbar>

		<v-form class="form-element hasToolbar hasBigFooter grey-back" id="form" v-if="productData">

			<v-alert style="height:42px" :value="true" color="warning pt-0 pb-0 pr-0" transition="slide-y-transition" v-if="transactionCount>=1">
              <v-layout row wrap style="align-items:center">
                <v-flex xs8 sm8 md8><v-icon class="font20 whitecolor mr-2">error_outline</v-icon> Set Auto Data Backup</v-flex>
                <v-flex xs4 sm4 md4 right-align>
                  <v-btn style="color:#fff" capitalize flat small @click="fn_gotoSetupDrive">Setup Now</v-btn>
                </v-flex>
              </v-layout>
            </v-alert>

			<div>

				<v-list full-width nopadding>
				  	<v-list-tile>
			          	<v-list-tile-content>
			              <v-list-tile-title>Date</v-list-tile-title>
			            </v-list-tile-content>

			            <span v-if="Form.transactionData.transactionDate">{{Form.transactionData.transactionDate | moment("DD-MMM-YYYY")}}</span>	
            			<span v-else>DD-MMM-YYYY</span>

			            <v-list-tile-action class="action-small">
            				<v-btn flat icon color="primary" @click.native="fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker')" class="no-left-margin">

            					<v-icon>date_range</v-icon>	
            				</v-btn>
			            </v-list-tile-action>
				    </v-list-tile>
				</v-list>

				<v-layout margin-top-ten row wrap white-background padding-top-bottom-ten>

					<v-flex xs12 sm12 md12 form-item>

						<v-text-field 
							:disabled="true"
							:hide-details="true"
							:value="productData.name" 
							label="Item Name"
							placeholder=" ">
						</v-text-field>

						<div custom-message>
		               		<span v-for="(item, index) in summaryArray" v-if="summaryArray.length">
           						Stock: <span :class="[item.qty<0 ? 'redcolor' : 'greencolor']">{{item.roundOffQty}} {{item.unitName}}</span>
		               		</span>
		               </div>
		               
		            </v-flex>

					<v-flex xs12 sm12 md12 form-item @click="fn_openGodowns('android', 'Godowns', 'ref_fieldGodown')" v-if="$root.TransactionSettings.enableGodown">
		               <v-text-field  
			               	readonly
			               	v-model="Form.godownName" 
			               	label="Select Godown"
							:onUpdate="fn_updateGodown" 
			               	ref="ref_fieldGodown"
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
		               		required>
		               </v-text-field>
		            </v-flex>

						<!-- <v-text-field 
							id="quantity_field"
							:prefix="type == 'minus' ? '(-)' : '(+)'"
							v-model.number="Form.qty" 
							label="Quantity"
							type="number"
							placeholder=" " 
							v-validate="'required|numeric|max:8'" 
							data-vv-name="quantity" 
							:error-messages="errors.collect('quantity')"
							required>
						</v-text-field> -->
						
						<!-- <template v-if="!Form.productBatches || !Form.productBatches.length || !$root.TransactionSettings.enableBatch"> -->
						<template>
							<v-flex xs6 sm6 md6 pl-3 pr-2>
								<v-text-field 
								:disabled="Form.productBatches && Form.productBatches.length && $root.TransactionSettings.enableBatch ? true : false"
									id="quantity_field"
									:prefix="type == 'minus' ? '(-)' : '(+)'"
									@input="$root.fn_boundDecimalLength(Form, null, 'qty')"
									v-model="Form.qty" 
									label="Quantity"
									type="number"
									placeholder=" " 
									v-validate="'required'" 
									data-vv-name="quantity" 
									:error-messages="errors.collect('quantity')"
									required>
								</v-text-field>
							
							</v-flex>

							<!-- <v-flex xs6 sm6 md6 pr-3 pl-2>

								<v-text-field 
									label="Unit"
									:disabled="true"
									:value="productData.productVariants[0].unitName"
									placeholder=" ">
								</v-text-field>
							
							</v-flex> -->
							<template v-if="productData && productData.productVariants && productData.productVariants.length">
								<v-flex xs6 sm6 md6 pr-3 pl-2 v-for="(item, vIndex) in productData.productVariants" :key="vIndex">
									<v-text-field 
										v-if="!item.secondaryUnitId"
										:disabled="true"
										:value="item.unitName"
										label="Unit"
										placeholder=" ">
									</v-text-field>

									<v-select
										v-else
										:items="[{itemId:item.unitId, itemName:item.unitName}, {itemId:item.secondaryUnitId, itemName:item.secondaryUnitName}]"
										label="Unit"
										:disabled="Form.selectedBatchType == 2 && Form.productBatches && Form.productBatches.length"
										item-text="itemName"
										item-value="itemId"
										v-model="Form.selectedUnit"
										:hide-details="true"
										return-object
										ref="ref_unitSelection"
										@change="fn_unitChange($event, item)"
									></v-select>

									<div class="pb-3 pt-1 right-align" v-if="item.secondaryUnitId">{{ item.packQuantity }} {{ item.unitName }} = {{ item.secondaryUnitPackQuantity }} {{ item.secondaryUnitName }}</div>
								</v-flex>
							</template>
						</template>

						<v-flex xs12 sm12 md12 form-item>

							<v-text-field 
								v-model.number="Form.rate"
								type="number" 
								:label="productData.productVariants[0].secondaryUnitId ? 'Rate (Per ' + Form.selectedUnit.itemName + ')' : 'Rate (Per ' + productData.productVariants[0].unitName + ')'"
								placeholder=" "
								v-validate="'min_value:0|decimal:2'" 
								data-vv-name="rate" 
								:error-messages="errors.collect('rate')"
								required>
							</v-text-field>

						</v-flex>

		            
				</v-layout>

				<div class="pt-2 grey-back full-width" v-if="$root.TransactionSettings.enableBatch">
					<template v-if="hasSeries && !hasOnlySeries">
						<v-radio-group class="pt-3 pl-3 pr-3 pb-1" white-background hide-details v-model="Form.selectedBatchType" row @change="fn_changeBatchType($event)">
							<v-radio label="Batch" :value="1"></v-radio>
							<v-radio label="Series" :value="2"></v-radio>
						</v-radio-group>
						<v-divider></v-divider>
					</template>

					<v-subheader class="white-background">
						<template v-if="Form.selectedBatchType == 2"><span v-for="(field, index) in $root.TransactionSettings.batchFields" :key="field.title" v-if="field.id == 'field1' || field.id == 'field2' || field.id == 'field3'">{{ field.title }}<span v-if="$root.TransactionSettings.batchFields.length - 1 != index">/</span></span></template>
						<template v-else>Batches</template>
						<v-spacer></v-spacer> 
						<v-btn small flat outline capitalize color="primary" style="border-radius:5px;" nomargin :ripple="false" @click="fn_openDialogSelectBatch">
							<v-icon class="mr-1" font16 color="primary">add</v-icon> Add / Select
						</v-btn>
					</v-subheader>

					<!-- <v-subheader class="pr-0 white-background">Batches <v-spacer></v-spacer> 
						<v-btn color="primary"  capitalize flat class="mr-0" @click="fn_openDialogSelectBatch">Select Batch <v-icon color="primary" class="ml-1">keyboard_arrow_down</v-icon></v-btn> 
					</v-subheader> -->
					<v-card flat v-for="(batch, batchIndex) in Form.productBatches" :key="batchIndex" v-if="fn_showHideBatches(batch)">
						<v-divider></v-divider>
						<v-card-text class="pb-2">
							<div style="float: left;margin-right: 12px;">
								<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
							</div>
							<v-layout class="batch_layout" row wrap>
								<!-- <v-flex xs2 sm2 md2 mb-2>
									<v-btn small nomargin icon flat @click="fn_removeBatch(batchIndex)"><v-icon>close</v-icon></v-btn>
								</v-flex> -->
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchNumber">
									<div light-opacity-color>Batch No.</div>
									<div>{{ batch.batchNumber }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchSize">
									<div light-opacity-color>Size</div>
									<div>{{ batch.batchSize }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.batchMRP">
									<div light-opacity-color>MRP</div>
									<div>{{ batch.batchMRP }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.mfgDate">
									<div light-opacity-color>Mfg. Date</div>
									<div v-if="batch.mfgDate">{{ batch.mfgDate | moment($root.batchDateFormat) }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.expDate">
									<div light-opacity-color>Exp. Date</div>
									<div v-if="batch.expDate">{{ batch.expDate | moment($root.batchDateFormat) }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.purchaseRate">
									<div light-opacity-color>Purchase Rate</div>
									<div>{{ batch.purchaseRate }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field1">
									<div light-opacity-color>Serial Number</div>
									<div>{{ batch.field1 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field2">
									<div light-opacity-color>IMEI Number</div>
									<div>{{ batch.field2 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field3">
									<div light-opacity-color>Part Number</div>
									<div>{{ batch.field3 }}</div>
								</v-flex>
								<v-flex xs4 sm4 md4 mb-2 v-if="batch.field4">
									<div light-opacity-color>Model Number</div>
									<div>{{ batch.field4 }}</div>
								</v-flex>
							</v-layout>

							<v-layout row wrap style="padding-left: 40px;" v-if="Form.selectedBatchType == 1">
								<!-- <v-flex xs4 sm4 md4 pr-2 :class="{'error_background':batch.currentStock<0}">
									<v-text-field
										readonly
										:error="batch.currentStock<0"
										label="Stock"
										:value="batch.currentStock ? batch.currentStock : 0"
										placeholder=" "
									></v-text-field>
								</v-flex> -->

								<v-flex xs6 sm6 md6>
									<v-text-field
										label="Quantity"
										v-model.number="batch.productQty"
										@input="fn_changeBatchQty"
										type="number"
										placeholder=" "
										:hide-details="true"
									></v-text-field>
								</v-flex>

								<v-flex xs6 sm6 md6 pl-3>
									<v-text-field
										label="Unit"
										:disabled="true"
										:hide-details="!errors.has('fields.qty')"
										:value="Form.selectedUnit ? Form.selectedUnit.itemName : productData.productVariants[0].unitName"
									></v-text-field>
								</v-flex>

								<v-flex xs12 sm12 md12 pt-1 pb-1 pr-2 right-align :class="{'error_background redcolor':batch.currentStock<0}">
									Current Stock: {{ batch.currentStock ? batch.currentStock : 0 }} {{ productData.productVariants[0].unitName }}
								</v-flex>

								<v-flex xs12 sm12 md12 redcolor pb-2 v-if="batch.expDate && fn_checkDate(batch)">
									<v-icon class="mr-1 font16 redcolor">info_outline</v-icon> Expired {{ fn_getDate(batch) }}
								</v-flex>
							</v-layout>
						</v-card-text>
					</v-card>
				</div>

				<v-layout wrap margin-top-ten white-background>
					<v-list full-width nopadding>
					  	<v-list-tile>

					  		<v-list-tile-action v-if="Form.transactionData.notes">
				            	<v-btn icon @click="Form.transactionData.notes = ''">
						  			<v-icon>close</v-icon>
						  		</v-btn>
				            </v-list-tile-action>

				          	<v-list-tile-content full-width @click="fn_addNote">
				              <v-list-tile-title medium-theme-color>Notes</v-list-tile-title>
							  <v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
				            </v-list-tile-content>
							
					    </v-list-tile>
					</v-list>

					<v-card full-width flat class="note-card" v-if="Form.transactionData.notes">
						<v-divider></v-divider>
					  	<v-card-text font16 v-html="Form.transactionData.notes" white-space-pre-line></v-card-text>
					</v-card>
				</v-layout>

				
			</div>	

		</v-form>

	    <div white-background full-width nopadding style="position:fixed;bottom:0;" v-if="productData">
			<v-layout row wrap>

				<template v-if="Form.productBatches && Form.productBatches.length">
					<v-flex xs6 sm6 md6 pl-3 pt-2 pb-1 left-align>Total Qty:</v-flex>
    	  			<v-flex xs6 sm6 md6 pr-3 pt-2 pb-1 right-align>{{Form.qty}} {{ Form.selectedUnit ? Form.selectedUnit.itemName : productData.productVariants[0].unitName }}</v-flex>
				</template>
				

				<v-flex xs6 sm6 md6 pl-3 pt-2 pb-2 left-align>Total Value</v-flex>
    	  		<v-flex xs6 sm6 md6 pr-3 pt-2 pb-2 right-align>&#8377; {{$root.numberToLocale(totalAmount)}}</v-flex>

				<v-flex xs12 sm12 md12 height48>
					<v-btn color="primary" full-height nomargin block no-round-borders noshadow :disabled="disabledBtn" @click="fn_checkValidations">Save</v-btn>
				</v-flex>
			</v-layout>
		</div>


	    <dialog-note ref="ref_dialogNote"></dialog-note>
		<dialog-date-picker ref="ref_dialogDatePicker" :updateDate="fn_updateDate"></dialog-date-picker>

		<dialog-drive-alert ref="ref_dialogDriveAlert" :gotoSetupDrive="fn_setupDrive" :skipAlert="fn_closeDialog" :transactionCount="transactionCount"></dialog-drive-alert>

		<dialog-select-batch ref="ref_dialogSelectBatch" :appendBatches="fn_appendBatches" :pid="productData.productId" :productData="productData" :openDatePicker="fn_openDatePicker" :formType="type=='minus' ? 'outward' : 'inward'" :selectedUnit="Form.selectedUnit" v-if="productData"></dialog-select-batch>
		<dialog-datepicker-batch ref="ref_dialogDatePickerBatch" :selected="selectedDate" :updateDate="fn_updateBatchDate"></dialog-datepicker-batch>

	    <!-- fn_draftAction is in draft mixin -->
	    <!-- <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations"></dialog-discard> -->

	</div>
</template>

<script>
const dialogjs =  require('../../../masters/forms/dialog').dialogjs;
const transactionData = require('../../datamodel').data.transactionData;
import dialogNote from '../dialogs/dialog_note'
import dialogDatePicker from './dialogs/dialog_datepicker'

import dialogDriveAlert from '../../../dialogs/dialog_drive_alert'
// import dialogDiscard from '../../../dialogs/dialog_discard'
// import {draftMixin} from '../../../draft_mixin'
import {transactionMixin} from '../../transaction_mixin'

import dialogSelectBatch from '../dialogs/dialog_select_batch'
import dialogDatepickerBatch from '../../../dialogs/dialog_datepicker_batch'

	export default{
		props:['settings'],
		// mixins: [draftMixin, transactionMixin],
		mixins: [transactionMixin],
		data(){
			return{

				Form:{
					"transactionData":JSON.parse(JSON.stringify(transactionData)),
					"rate":null,
					"qty":null,
					"batches":[],
					"productBatches":[],
					"selectedBatchType":null,
					"selectedUnit":null,
					"godownId":null,
					"godownName":null
				},
				productData:null,
				summaryArray:null,
				loading:true,
				tagId:null,
				draftStorageId:null,
				dialogStorageId:null,
				backButtonPress: false,
				// unwatch:false,
				disabledBtn:false,
				type:"plus",
				hasOnlySeries:true,
				hasSeries:false,
				selectedDate:null,
				dateType:null,
			}
		},
		components:{
			'dialog-note':dialogNote,
			'dialog-date-picker':dialogDatePicker,
			'dialog-drive-alert':dialogDriveAlert,
			'dialog-select-batch':dialogSelectBatch,
			'dialog-datepicker-batch':dialogDatepickerBatch
			// 'dialog-discard': dialogDiscard,
		},
		// watch:{
		// 	'Form': {
  //               handler: function (newVal, oldVal){
  //                    // this.fn_saveToLocalStorage(this);

  //                    let name = this.Form.transactionProductsTemp.length ? this.Form.transactionProductsTemp[0].productName : '';

  //                    if(!this.unwatch){
  //                    	this.fn_saveDraft(name);
  //                    }
  //                    this.unwatch = false;

  //                    let self = this;
  //                    if(this.Form.trProducts.length){
  //                    	this.Form.trProducts.forEach(function (item) {
  //                    		item.variants.forEach(function (vItem) {
  //                    			self.fn_itemTotal(vItem, item.rate);
  //                    		})	
  //                    	})
  //                    }
  //                },
  //                deep: true
  //           }
		// },
		methods:{

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePickerBatch');
				})
			},

			fn_updateBatchDate: function (value) {
				this.$refs['ref_dialogSelectBatch'].fn_updateDate(value, this.dateType);
				this.fn_closeDialog();
			},


			fn_updateDate: function (value) {
				// this.Form.transactionData.transactionDate = value;
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(value);
				// this.Form.isNew ? this.fn_bindTransactionNumber() : '';
				this.fn_closeDialog();
			},

			fn_getSummary: function (itemId) {
				var self = this;
				this.getData('ProductSummary', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.summaryArray = JSON.parse(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getProductData: function (itemId, isEdit, tProducts) {
				var self = this;
				this.getData('Product', itemId, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.productData = JSON.parse(response);
				          	if(!isEdit){
				          		self.rate = self.productData.purchaseRate;
				          	}
				          	
				          	self.fn_getSummary(itemId);

							self.fn_getBatches(itemId);

							if(self.productData.productVariants[0].secondaryUnitId){
								if(isEdit){
									if(tProducts && tProducts.length && tProducts[0].variants.length){
										self.Form.selectedUnit = {};
										self.Form.selectedUnit.itemId = tProducts[0].variants[0].unitId;
										self.Form.selectedUnit.itemName = tProducts[0].variants[0].unitName;	
									}
								}
								else{
									self.Form.selectedUnit = {};
									self.Form.selectedUnit.itemId = self.productData.productVariants[0].unitId;
									self.Form.selectedUnit.itemName = self.productData.productVariants[0].unitName;
								}
								
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_getBatches: function(productId, addedBatches){
				let self = this;
				this.getData('GetProductBatchByProductId', productId, 
					{
						onSuccess: function(response){
							console.log(response);
							self.$set(self.Form, 'batches', JSON.parse(response));

							if(addedBatches && addedBatches.length){
								for(let i=0; i<addedBatches.length; i++){
									let bIndex = self.Form.batches.findIndex(bItem=>{return bItem.batchId == addedBatches[i].batchId});
									if(bIndex == -1){
										self.Form.batches.push(addedBatches[i]);
									}
								}
							}
							// if(self.$parent.Form.productData.batches && self.$parent.Form.productData.batches.length){
							// 	self.$parent.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
							// }
						}, 
						onError: function(error){
							console.log(error);
						}
					}
				);
			},
			fn_openDialogSelectBatch: function(){
				if(this.Form.productBatches && this.Form.productBatches.length){
					for(let i=0; i<this.Form.batches.length; i++){
						this.Form.batches[i].productQty = null;
						this.Form.batches[i].selected = false;
						for(let j=0; j<this.Form.productBatches.length; j++){
							if(this.Form.productBatches[j].batchId == this.Form.batches[i].batchId){
								if(this.Form.productBatches[j].productQty){
									this.Form.batches[i].selected = true;
									this.Form.batches[i].productQty = this.Form.productBatches[j].productQty;
								}
							}
						}
					}
				}
				this.fn_openDialogWeb('web', 'Batches', 'ref_dialogSelectBatch');
			},
			fn_newBatch: function(){
				this.backButtonPress = false;
				this.$router.push({path:"/product/batches", query:{pid:this.productData.productId, dialog:1, new:1}});
			},
			fn_changeProductQty: function(item){
				if(this.Form.productBatches && this.Form.productBatches.length && this.Form.productBatches.length == 1){
					this.Form.productBatches[0].productQty = item.qty;
				}
			},
			fn_changeBatchQty: function(){
				if(this.Form.productBatches && this.Form.productBatches.length){
					let totalVal = 0;
					for(let i=0; i<this.Form.productBatches.length; i++){
						totalVal += this.Form.productBatches[i].productQty;
					}
					this.Form.qty = Number(totalVal);
				}
			},
			

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			// fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
			// 	// this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			// 	this.fn_updateProductName(selectedValueId, selectedValueName, isRemoved);
			// },


			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_getData: function (type, itemId) {
				this.Form.isNew = false;
				let filterObject = {};
				filterObject.type = this.settings.transactionTypeId;

				let self = this;
				this.getFilterData(type, itemId, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = JSON.parse(response);
							self.fn_bindingData(data);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_bindingData: function (data) {
				// this.fn_getTransactionTypeData(data.transactionTypeFormId, null, false);
				this.Form.transactionData.additionalData = data.additionalData;
				this.Form.transactionData.amount = data.amount;
				this.Form.transactionData.businessId = data.businessId;
				this.Form.transactionData.createdBy = data.createdBy;
				this.Form.transactionData.createdDate = data.createdDate;
				this.Form.transactionData.currencyId = data.currencyId;
				this.Form.transactionData.dueDate = data.dueDate;
				this.Form.transactionData.dueType = data.dueType;
				this.Form.transactionData.modifiedBy = data.modifiedBy;
				this.Form.transactionData.modifiedDate = data.modifiedDate;
				this.Form.transactionData.notes = data.notes;
				this.Form.transactionData.partyId = data.partyId;
				this.Form.transactionData.paymentMode = data.paymentMode;
				this.Form.transactionData.prefix = data.prefix;
				this.Form.transactionData.refDate = data.refDate;
				this.Form.transactionData.refNumber = data.refNumber;
				this.Form.transactionData.roundedAmount = data.roundedAmount;
				this.Form.transactionData.salesmanId = data.salesmanId;
				this.Form.transactionData.status = data.status;
				this.Form.transactionData.suffix = data.suffix;
				this.Form.transactionData.transactionDate = data.transactionDate;
				this.Form.transactionData.transactionId = data.transactionId;
				this.Form.transactionData.transactionListId = data.transactionListId;
				this.Form.transactionData.transactionNumber = data.transactionNumber;
				this.Form.transactionData.mergeTransactionNumber = data.mergeTransactionNumber;
				// this.Form.transactionProductsTemp = JSON.parse(JSON.stringify(data.transactionProducts));
				let products = JSON.parse(JSON.stringify(data.transactionProducts));
				this.Form.rate = products[0].variants[0].rate;
				this.Form.qty = products[0].variants[0].qty;
				this.type = products[0].variants[0].transactionProductMode ? 'plus' : 'minus';

				this.Form.selectedBatchType = products[0].selectedBatchType;

				if(products[0].transactionProductBatches && products[0].transactionProductBatches.length){
					this.Form.productBatches = [];
					for(let i=0; i<products[0].transactionProductBatches.length; i++){
						products[0].transactionProductBatches[i].productQty = products[0].transactionProductBatches[i].qty;
						this.Form.productBatches.push(JSON.parse(JSON.stringify(products[0].transactionProductBatches[i])))
					}
				}

				if(data.fromGodownId && data.fromGodownName){
					this.Form.godownId = data.fromGodownId;
					this.Form.godownName = data.fromGodownName;
				}
				else if(data.toGodownId && data.toGodownName){
					this.Form.godownId = data.toGodownId;
					this.Form.godownName = data.toGodownName;
				}

				this.fn_getProductData(data.productId, true, products);

				// this.Form.transactionTypeFormId = data.transactionTypeFormId;
				// this.Form.transactionTypeFormName = data.transactionTypeFormName;

				// this.Form.transactionData.numberSeriesId = data.numberSeriesId;
				// this.Form.transactionData.transactionNumberId = data.transactionNumberId;

				// let self = this;
				// this.Form.transactionProductsTemp.forEach(function (item) {
				// 	item.transactionProductMode = item.variants[0].transactionProductMode;
				// 	self.fn_getGroupTotal(item);
				// });

				// setTimeout(function(){
				// 	self.$root.fn_copyFormObject(self.Form, self.formId);
				// },500);
			},

			fn_checkValidations: function(){
				this.disabledBtn = true;
				this.showLoading('Please Wait...');
				this.$validator.validateAll().then((result) => {
			        if (result) {
			        	this.fn_post();
			    	}
			    	else{
			    		this.disabledBtn = false;
			    		this.hideLoading();
			    	}
			    });
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('TransactionProducts', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.hideLoading();

							let adjustmentType = self.type == 'minus' ? 'stock_reduced' : 'stock_added'; 

							// posting metrics on save
							let postObj = {"eventName":'stock_adjustment_save',"eventData":[{"eventKey":"adjust_type","eventValue":adjustmentType}]}
				          	
							let saveObj = {};
							saveObj.eventKey = "transaction_save";
							saveObj.eventValue = adjustmentType;
							postObj.eventData.push(saveObj);
							
							self.$root.fn_postMetrics(postObj);
							
							self.fn_goBack();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				          	let response = JSON.parse(error);
				         	if(response && response.negativeProducts && response.negativeProducts.length){
				         		self.fn_shortListInvalidItems(response.negativeProducts);
				         	}
				        }
					}
		        );
			},

			fn_post: function(){

				//only in case of new transaction
				if(!this.Form.transactionData.transactionId){
					this.Form.transactionData.transactionId = this.guid();
					// this.Form.transactionData.createdDate = new Date();
					this.Form.transactionData.createdDate = this.$root.fn_getLocalDateFormat();
					this.Form.transactionData.transactionListId = this.settings.transactionTypeId;
				}

				// this.Form.transactionData.modifiedDate = new Date();
				this.Form.transactionData.modifiedDate = this.$root.fn_getLocalDateFormat();

				this.Form.transactionData.amount = this.totalAmount;
				this.Form.transactionData.roundedAmount = this.totalAmount
				this.Form.transactionData.status = 1;
				this.Form.transactionData.transactionTypeFormId = this.Form.transactionTypeFormId;
				this.Form.transactionData.refDate = null;

				// this.Form.transactionProducts = [];
				let transactionProducts = [];

				let tpObj = {};

				tpObj.transactionProductId = this.guid();
				tpObj.transactionId = this.Form.transactionData.transactionId;
				tpObj.productId = this.productData.productId;
				tpObj.productVariantId = this.productData.productVariantId;
				tpObj.groupId = this.guid();
				tpObj.mrp = null;
				tpObj.rate = this.Form.rate ? this.Form.rate : 0;
				tpObj.additionalData = null;
				// tpObj.unitId = this.productData.productVariants[0].unitId;
				tpObj.unitId = this.Form.selectedUnit ? this.Form.selectedUnit.itemId : this.productData.productVariants[0].unitId;
				tpObj.primaryUnitId = this.productData.productVariants[0].variantBaseUnitId;
				// tpObj.primaryUnitId = this.productData.productVariants[0].primaryUnitId;
				if(this.productData.productVariants[0].secondaryUnitId){
					tpObj.secondaryUnitId = this.productData.productVariants[0].secondaryUnitId;	
				}

				if(this.productData.productVariants[0].secondaryUnitPackQuantity){
					tpObj.secondaryUnitPackQuantity = this.productData.productVariants[0].secondaryUnitPackQuantity;	
				}

				tpObj.qty = this.Form.qty;
				tpObj.packQuantity = this.productData.productVariants[0].packQuantity ? this.productData.productVariants[0].packQuantity : 1;
				tpObj.amount = this.totalAmount;
				// net amount col post added on 12-mar-2026 just to	make it consistent with other transaction types,
				// before 12-mar-2026 we were using netAmount col for average rate calculation in stock adjustment transaction products, but now we are using amount col for average rate calculation as per discussion with backend team, so posting netAmount same as amount in stock adjustment transaction products
				// average rate is calculating thru amount col in stock adjustment transaction products as per discussion with backend team
				tpObj.netAmount = this.totalAmount;
				tpObj.taxableValue = this.totalAmount;
				tpObj.selectedBatchType = this.Form.selectedBatchType;
				if(this.type == 'minus'){
					tpObj.transactionProductMode = 0;
					tpObj.actualQty = -this.Form.qty;
					tpObj.fromGodownId = this.Form.godownId;
				}
				else{
					tpObj.transactionProductMode = 1;
					tpObj.actualQty = this.Form.qty;
					tpObj.toGodownId = this.Form.godownId;
				}

				if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
					tpObj.actualQty = this.roundUpto5Decimals((tpObj.actualQty * tpObj.packQuantity) / this.productData.productVariants[0].secondaryUnitPackQuantity);
				}

				transactionProducts.push(tpObj);

				// for(let i=0; i<this.Form.transactionProductsTemp.length; i++){
				// 	let tP = this.Form.transactionProductsTemp[i];

				// 	for(let j=0; j<tP.variants.length; j++){

				// 		let variant = tP.variants[j];

				// 		let tpObj = {};

				// 		if(variant.qty){

				// 			!variant.transactionProductId ? tpObj.transactionProductId = this.guid() : tpObj.transactionProductId = variant.transactionProductId;

				// 			tpObj.transactionId = this.Form.transactionData.transactionId;

				// 			tpObj.productId = variant.productId;

				// 			tpObj.productVariantId = variant.productVariantId;

				// 			tpObj.groupId = tP.groupId;

				// 			// tpObj.mrp = tP.mrp ? tP.mrp : null;

				// 			// tpObj.rate = tP.rate ? tP.rate : null;

				// 			tpObj.mrp = tP.mrp;

				// 			tpObj.rate = tP.rate;

				// 			tpObj.additionalData = null;

				// 			tpObj.unitId = variant.unitId;

				// 			tpObj.primaryUnitId = variant.primaryUnitId;

				// 			tpObj.qty = variant.qty;

				// 			tpObj.packQuantity = variant.packQuantity ? variant.packQuantity : 1;

				// 			tpObj.amount = variant.amount;

				// 			tpObj.taxableValue = variant.taxableValue;

				// 			tpObj.transactionProductMode = tP.transactionProductMode;

				// 			!tP.transactionProductMode ? tpObj.actualQty = -variant.qty : tpObj.actualQty = variant.qty;

				// 			// this.Form.transactionProducts.push(tpObj);
				// 			transactionProducts.push(tpObj);

				// 		}
				// 		// else{
				// 		// 	if(this.Form.transactionData.transactionId){
				// 		// 		let obj = {};
				// 		// 		obj.transactionProductId = variant.transactionProductId;
				// 		// 		this.Form.deletedTransactionProductIds.push(obj);
				// 		// 	}
				// 		// }

				// 	}

				// }

				let postObj = {};

				postObj = this.Form.transactionData;
				postObj.transactionProducts = transactionProducts;

				postObj.masterProductBatches = [];
				postObj.transactionProductBatches = [];

				postObj.fiscalYear = JSON.stringify(this.fn_getFiscalYear(this.Form.transactionData.transactionDate));
				postObj.sortDate = this.$moment(this.Form.transactionData.transactionDate).format('YYYY-MM-DD');

				if(this.Form.selectedBatchType == 2){
					this.Form.productBatches = this.Form.productBatches.filter(batch=>{
						return batch.field1 || batch.field2 || batch.field3
					})
				}
				else{
					this.Form.productBatches = this.Form.productBatches.filter(batch=>{
						return !batch.field1 && !batch.field2 && !batch.field3
					})
				}

				if(this.Form.productBatches && this.Form.productBatches.length){
					//adding batches to transaction
					for(let i=0; i<this.Form.productBatches.length; i++){
						let obj = {};
						obj.productId = this.productData.productId;
						obj.transactionProductBatchId = this.guid();
						obj.batchId = this.Form.productBatches[i].batchId;
						obj.transactionProductId = tpObj.transactionProductId;
						obj.qty = this.Form.productBatches[i].productQty;
						obj.orderNumber = i + 1;
						obj.transactionId = this.Form.transactionData.transactionId;
						obj.transactionListId = this.Form.transactionData.transactionListId;
						if(this.type == 'minus'){
							obj.actualQty = -this.Form.productBatches[i].productQty;
						}
						else{
							obj.actualQty = this.Form.productBatches[i].productQty;
						}

						if(this.Form.selectedUnit && this.Form.selectedUnit.itemId && this.Form.selectedUnit.itemId != tpObj.primaryUnitId){
							obj.actualQty = this.roundUpto5Decimals((obj.actualQty * tpObj.packQuantity) / this.productData.productVariants[0].secondaryUnitPackQuantity);
						}
						
						postObj.transactionProductBatches.push(obj);

						if(this.Form.productBatches[i].isNew){
							delete this.Form.productBatches[i].isNew;
							this.Form.productBatches[i].productId = this.productData.productId;
							this.Form.productBatches[i].orderNumber = this.Form.batches.length + (i + 1);
							postObj.masterProductBatches.push(this.Form.productBatches[i]);
						}
					}
				}

				if(this.type == 'minus'){
					postObj.fromGodownId = this.Form.godownId;
				}
				else{
					postObj.toGodownId = this.Form.godownId;
				}
				
				console.log(this.Form);
				this.fn_saveLocal(postObj);
			},

			fn_addNote: function () {
				this.$refs['ref_dialogNote'].noteValue = this.Form.transactionData.notes;
				this.fn_openDialogWeb('web', 'Note', 'ref_dialogNote');
				setTimeout(function(){
					let noteField = document.getElementById('noteField');
					noteField.focus();
				});
			},

			fn_saveNote: function () {
				this.Form.transactionData.notes = this.$refs['ref_dialogNote'].noteValue;
				this.fn_closeDialog();
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_appendBatches: function(batches){
				if(batches.length){
					this.$set(this.Form, 'productBatches', JSON.parse(JSON.stringify(batches)));
					// this.Form.productData.items[0].batches = JSON.parse(JSON.stringify(batches));
					let totalQty = 0;
					for(let i=0; i<this.Form.productBatches.length; i++){
						totalQty += Number(this.Form.productBatches[i].productQty);
					}
					this.Form.qty = Number(totalQty);

					if(this.productData && this.Form.selectedBatchType == 2){
						this.Form.selectedUnit = {"itemId":this.productData.productVariants[0].unitId, "itemName":this.productData.productVariants[0].unitName};
					}
				}
				this.fn_closeDialog();
			},

			fn_removeBatch: function(batchIndex){
				this.Form.productBatches.splice(batchIndex, 1);
				let totalQty = 0;
				for(let i=0; i<this.Form.productBatches.length; i++){
					totalQty = totalQty + Number(this.Form.productBatches[i].productQty);
				}
				this.Form.qty = totalQty ? totalQty : null;
			},

			fn_showHideBatches: function(field){
				if(this.Form.selectedBatchType == 2 && !field.batchNumber && !field.batchMRP && !field.batchSize && !field.mfgDate && !field.expDate && !field.opening && !field.field4){
					return true;
				}
				else if(this.Form.selectedBatchType == 1 && !field.field1 && !field.field2 && !field.field3){
					return true;
				}
				else{
					return false;
				}
			},

			// fn_unitChange: function(value, item){
			// 	let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
			// 	if(currentItemId != value.itemId){
			// 		if(value.itemId == item.secondaryUnitId){
			// 			this.Form.rate = this.roundUpto2Decimals(this.Form.rate / item.secondaryUnitPackQuantity);
			// 		}
			// 		else{
			// 			this.Form.rate = this.roundUpto2Decimals(this.Form.rate * item.secondaryUnitPackQuantity);
			// 		}
			// 	}
			// },

			fn_unitChange: function(value, item){
				let currentItemId = this.$refs.ref_unitSelection[0]._data.selectedItems[0].itemId;
				if(currentItemId != value.itemId){
					if(value.itemId == item.secondaryUnitId){
						this.Form.rate = (this.Form.rate * item.packQuantity) / item.secondaryUnitPackQuantity;

					}
					else{
						this.Form.rate = (this.Form.rate * item.secondaryUnitPackQuantity) / item.packQuantity;
						// product.rate = this.roundUpto2Decimals(product.rate * item.secondaryUnitPackQuantity);
					}
					// this.tempRate = this.Form.rate;
					this.Form.rate = this.roundUpto2Decimals(this.Form.rate); 
				}
			},

			// fn_assignTempValue: function(val){
			// 	this.tempRate = val;
			// },

			fn_changeBatchType: function(val){
				if(val==2 && this.Form.productBatches && this.Form.productBatches.length){
					if(this.Form.selectedUnit){
						this.Form.selectedUnit = {"itemId":this.productData.productVariants[0].unitId, "itemName":this.productData.productVariants[0].unitName}
					}
				}
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				if(menuAction=='newgodown'){
					this.fn_newGodown();
				}
			},

			fn_setNewItem: function(){
				let itemData = null;
				if(localStorage.getItem('newItem')){

					itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "godown":
					    	this.fn_updateGodown(itemData.id, itemData.name, false);
					        break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			}
		},
		mounted: function(){

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_transaction_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			// !this.$root.CurrentBusiness.DataDrive ? this.fn_checkTransactionCount() : '';
			if(!this.$root.CurrentBusiness.DataDrive){
				this.fn_checkTransactionCount(()=>{
					if(this.transactionCount>=3 || this.fn_differenceOfDays() > 7){
						this.fn_openDialogDriveSetup();
					}
				})
			}

			var formsArray = [];
			if(localStorage.getItem('stockadjustments')){
				formsArray = JSON.parse(localStorage.getItem('stockadjustments'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('stockadjustments', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			this.unwatch = true;
			// this.Form.isNew ? this.Form.transactionData.transactionDate = new Date() : '';
			// this.Form.transactionData.transactionDate = new Date();
			if(new Date().getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat(this.$root.CurrentBusiness.OpeningDate);
			}
			else{
				this.Form.transactionData.transactionDate = this.$root.fn_getLocalDateFormat();	
			}

			// let formElement = document.getElementsByClassName("form-element")[0];

			// formElement.addEventListener("submit", function(e){
			//     e.preventDefault();
			// });

			this.type = this.$route.query.type;

			if(this.$route.query.itemid && this.$route.name == 'newStockAdjustment'){
				this.fn_getProductData(this.$route.query.itemid);
			}
			

			if(this.$root.TransactionSettings.batchFields && this.$root.TransactionSettings.batchFields.length){
				for(let i=0; i<this.$root.TransactionSettings.batchFields.length; i++){
					let field = this.$root.TransactionSettings.batchFields[i]
					if(field.id == 'field1' || field.id == 'field2' || field.id == 'field3'){
						this.hasSeries = true;
					}

					if(field.id == 'batchNumber' || field.id == 'batchMRP' || field.id == 'purchaseRate' || field.id == 'batchSize' || field.id == 'mfgDate' || field.id == 'expDate' || field.id == 'field4'){
						this.hasOnlySeries = false;
					}
				}
			}

			if(!this.Form.selectedBatchType){
				this.Form.selectedBatchType = !this.hasOnlySeries ? 1 : 2;
			}

			// setTimeout(() => {
			// 	if(localStorage.getItem('batch_data')){
			// 		if(!this.Form.productBatches || !this.Form.productBatches.length){
			// 			this.Form.productBatches = [];
			// 		}
			// 		let bArray = JSON.parse(localStorage.getItem('batch_data'));
			// 		for(let i=0; i<bArray.length; i++){
			// 			bArray[i].productQty = null;
			// 			this.Form.batches.push(bArray[i]);
			// 			this.Form.productBatches.push(bArray[i]);
			// 			this.$forceUpdate();
			// 		}

			// 		localStorage.removeItem('batch_data');
			// 	}
			// }, 1000);

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Transaction', this.toolbarTitle);

		},
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					if(this.transactionCount >= 10 && this.$refs['ref_dialogDriveAlert'].backupAlertSheet){
						this.fn_draftAction(true);
						next(true);
					}
					else{
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						this.backButtonPress = false;
						next(false);
					}
				}
				else{
					localStorage.removeItem("SetDataDrive");
					next(true);
				}
			}
			else{
				next(true);
			}
	    },
	    beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		let itemId = null;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){//from display view
					itemId = from.params.tagId;
					vm.fn_getData('TransactionProducts', itemId);
				}

				//edit from list view
		  		// else if(from.name=='stockJournalItems' && (to.params && to.params.tagId)){
		  		// 	itemId = to.params.tagId;
		  		// }

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_getData('TransactionProducts', itemId);
		  		// 	}

		  		// 	let setTFT = !itemId && !isDraft;

		  		// 	vm.fn_getTransactionTypeList(setTFT);
		  		// })

		  	})
		},
	    computed:{
	    	totalAmount: function(){
	    		let rate = this.Form.rate ? this.Form.rate : 0;
	    		return this.roundUpto2Decimals(rate * this.Form.qty);
	    	}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/stock_adjustment/form.vue